import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { timer } from 'rxjs/observable/timer';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  constructor(public location : Router) { }

  ngOnInit() {
    var tim = timer(4000);
    tim.subscribe(t => {
     this.location.navigateByUrl('disclaimer')
    });
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/loader/loader.component.ts